import useApi from '../../api/backendApiContext';
import useAuth from '../authContext';
import { mobileConfig, pushNotificationsConfig } from '../../commons/config';
import { usePushNotificationState } from '../../push-notifications/hooks/usePushNotificationState';
import { useCallback } from 'react';

export const useSignOut = () => {
  const { pushNotificationsApi } = useApi();
  const {
    state: { user },
    dispatch,
  } = useAuth();
  const { state } = usePushNotificationState();

  const signOut = useCallback(async () => {
    if (
      user &&
      mobileConfig().isMobile &&
      pushNotificationsConfig.isEnabled &&
      state?.expoPushToken
    ) {
      try {
        await pushNotificationsApi.disablePushNotifications(user.userId, state.expoPushToken);
      } catch (e) {
        logger.error('Failed to disable push notifications', e);
      }
    }
    dispatch({ type: 'SIGNOUT' });
  }, [user, state?.expoPushToken, dispatch, pushNotificationsApi]);
  return { signOut };
};
